"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reward = void 0;
const GameCenterModuleStatusType_1 = require("../../enums/game-center/GameCenterModuleStatusType");
const GameCenterRewardType_1 = require("../../enums/game-center/GameCenterRewardType");
const RewardStockType_1 = require("../../enums/game-center/RewardStockType");
const Size_1 = require("../../enums/game-center/Size");
const game_center_asset_1 = require("../../utils/game-center-asset");
exports.reward = {
    isEnable: false,
    startDate: null,
    endDate: null,
    order: 1,
    name: 'NEW REWARD',
    rewardImage: (0, game_center_asset_1.getGameCenterAssetUrl)('half-reward.png'),
    rewardItemDescriptionText: '',
    size: Size_1.Size.HALF,
    rewardPrice: 1000,
    purchaseLimit: 0,
    totalPurchaseCount: 0,
    stockType: RewardStockType_1.RewardStockType.UNLIMITED,
    isRewardLock: false,
    unLockDays: 0,
    rewardLockImage: '',
    isRewardCoolDown: false,
    coolDownDays: 0,
    coolDownImage: '',
    rewardType: GameCenterRewardType_1.GameCenterRewardType.COUPON_CODE_GENERAL,
    couponUrl: '',
    couponCode: '',
    numberOfCoupon: 0,
    rewardEmailTitle: 'Thanks for your purchase',
    rewardEmailText: 'Here is your Reward',
    rewardEmailButtonText: 'Click to claim reward',
    status: GameCenterModuleStatusType_1.GameCenterModuleStatusType.ACTIVE,
    isStartDateCountDown: false,
    countDownImage: '',
    gamificationId: null,
    gamificationConditionId: null,
};
